import {
    LUA_SCRIPT_LIST_REQUEST,
    LUA_SCRIPT_LIST_SUCCESS,
    LUA_SCRIPT_LIST_FAILURE,
    LUA_SCRIPT_VIEW_REQUEST,
    LUA_SCRIPT_VIEW_SUCCESS,
    LUA_SCRIPT_VIEW_FAILURE,
    LUA_SCRIPT_UPDATE_REQUEST,
    LUA_SCRIPT_UPDATE_SUCCESS,
    LUA_SCRIPT_UPDATE_FAILURE,
    LUA_SCRIPT_ADD_REQUEST,
    LUA_SCRIPT_ADD_SUCCESS,
    LUA_SCRIPT_ADD_FAILURE,
} from '../actions/luaAction';


const initialState = {
  scripts: [],
  selectedScript: null,
  loading: false,
  error: null,
};


export const luaScriptReducer = (state = initialState, action) => {
  switch (action.type) {
    case LUA_SCRIPT_LIST_REQUEST:
    case LUA_SCRIPT_VIEW_REQUEST:
    case LUA_SCRIPT_UPDATE_REQUEST:
    case LUA_SCRIPT_ADD_REQUEST:
      return { ...state, loading: true, error: null };

    case LUA_SCRIPT_LIST_SUCCESS:
      return { ...state, loading: false, scripts: action.payload };

    case LUA_SCRIPT_VIEW_SUCCESS:
      return { ...state, loading: false, selectedScript: action.payload };

    case LUA_SCRIPT_UPDATE_SUCCESS:
    case LUA_SCRIPT_ADD_SUCCESS:
      return { ...state, loading: false }; // refresh via fetchLuaScripts again if needed

    case LUA_SCRIPT_LIST_FAILURE:
    case LUA_SCRIPT_VIEW_FAILURE:
    case LUA_SCRIPT_UPDATE_FAILURE:
    case LUA_SCRIPT_ADD_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};